import axios, { AxiosError } from 'axios';
import { CustomError } from '../../common/errors';
import NetworkError from '../../common/errors/networkError';
import Result from '../../common/result';
import { Resolver } from '../../config';
import {
  DeletionResponse,
  RetentionService,
  StatusRequest,
  DeletionStatusResult,
  PassRetentionRequest,
} from './retentionService';

export default class RetentionServiceImplementation implements RetentionService {
  private endpoint: string;

  constructor() {
    const serviceConfig = Resolver.getServiceConfig();
    this.endpoint = serviceConfig.retention.retentionEndpoint;
  }

  private static getErrorResult<TSuccess = boolean>(url: string, error: unknown): Result<CustomError, TSuccess> {
    const statusCode = (error as AxiosError)?.response?.status;
    return Result.failed(new NetworkError(`Network error calling ${url}`, statusCode || 500, error as Error));
  }

  async revoke(request: PassRetentionRequest): Promise<DeletionStatusResult> {
    const url = `${this.endpoint}/deletionRequest`;
    const result = await axios.request<DeletionResponse>({
      url,
      method: 'POST',
      data: request,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return Result.successful(result.data);
  }

  async deletionStatus(request: StatusRequest): Promise<DeletionStatusResult> {
    const url = `${this.endpoint}/deletionRequest/lookup`;

    try {
      const result = await axios.request<DeletionResponse>({
        method: 'POST',
        url,
        data: request,
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return Result.successful(result.data);
    } catch (error) {
      return RetentionServiceImplementation.getErrorResult(url, error);
    }
  }
}
